import { UIKitTheme } from 'ui/themes/getUIKitTheme'

export const getActiveBgColor = (theme: UIKitTheme, overColoredPad = false) => {
  if (overColoredPad) {
    return theme.uiKit.colors.theme.brand.darker
  }
  return theme.uiKit.colors.theme.brand.darker
}
